class SpecialMenuTabs extends HTMLElement {
  connectedCallback() {
    this.tablist = this.querySelector(':scope > .special-menu-tabs__tablist');
    this.panels = this.querySelector(':scope > .special-menu-tabs__panels');
    if (!this.tablist || !this.panels) return;

    this.tabs = Array.from(this.tablist.querySelectorAll(':scope > [data-special-tab]'));
    this.panelItems = Array.from(this.panels.querySelectorAll(':scope > .special-menu-tabs__panel'));
    this.tablist.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-special-tab]');
      if (!tab || !this.tablist.contains(tab)) return;
      event.preventDefault();
      event.stopPropagation();

      // A tab is content inside the special disclosure, never a request to
      // toggle the header menu itself.
      const specialDetails = this.closest('details.mega-menu--special');
      if (specialDetails && !specialDetails.open) specialDetails.open = true;
      this.select(tab.dataset.specialTab);
    });
  }

  select(panelId) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.specialTab === panelId;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active);
    });
    this.panelItems.forEach((panel) => {
      const active = panel.id === panelId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }
}

if (!customElements.get('special-menu-tabs')) customElements.define('special-menu-tabs', SpecialMenuTabs);

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.special-menu-close');
  if (!closeButton) return;

  event.preventDefault();
  event.stopPropagation();

  const megaMenu = closeButton.closest('details.mega-menu--special');
  if (megaMenu) {
    megaMenu.removeAttribute('open');
    megaMenu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    return;
  }

  const drawer = closeButton.closest('header-drawer');
  if (drawer?.closeMenuDrawer) {
    const drawerSummary = drawer.mainDetailsToggle?.querySelector('summary');
    drawer.closeMenuDrawer(new Event('click'), drawerSummary);
    drawerSummary?.setAttribute('aria-expanded', 'false');
    return;
  }

  const drawerDetails = closeButton.closest('.menu-drawer-container');
  drawerDetails?.removeAttribute('open');
  drawerDetails?.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
});
